<template>
  <b-navbar-nav class="nav align-items-center">
    <b-nav-item-dropdown
        id="dropdown-month"
        variant="link"
        class="dropdown-month"
    >
      <template #button-content>
        <h2>{{ currentMonth ? currentMonth.title : 'Выберите месяц' }}</h2>
      </template>
      <b-dropdown-item
          v-for="monthObj in months"
          :key="monthObj.id"
          @click="updateMonth(monthObj.id)"
      >
        <span class="ml-50">{{ monthObj.title }}</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-navbar-nav>
</template>

<script>
import {BNavItemDropdown, BDropdownItem, BNavbarNav} from 'bootstrap-vue'

export default {
  components: {
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
  },
  data() {
    return {
      months: [],
    }
  },
  computed: {
    currentMonth() {
      const currentMonthId = this.$store.state.appConfig.month || null
      if (!currentMonthId)
        return

      return this.months.find(m => m.id == currentMonthId) || this.months[0]
    },
  },
  methods: {
    updateMonth(monthId) {
      this.$store.commit('appConfig/UPDATE_MONTH', monthId)

      window.location.reload()
    }
  },
  created() {
    this.$http.get('/months?sort=date_begin DESC&limit=5').then(res => {
      this.months = res.data.data
      if (!this.$store.state.appConfig.month) {
        let activeMonth = this.months.find(m => m.is_actual) || this.months[0].id
        this.$store.commit('appConfig/UPDATE_MONTH', activeMonth)
      }
    })
  },
}
</script>

<style scoped>
.dropdown-month {
  min-width: 150px;
}
</style>
